export default class Rooms {
  constructor() {
    this.roomListItems = document.querySelectorAll('.js-room-list-item');

    this.init();
  }

  init() {
    this.roomListItems.forEach((roomListItem) => {
      const showRoomDetailsButton = roomListItem.querySelector('.js-show-room-details');
      const hideRoomDetailsButton = roomListItem.querySelector('.js-hide-room-details');

      showRoomDetailsButton && showRoomDetailsButton.addEventListener('click', () => this.showRoomDetails(roomListItem));
      hideRoomDetailsButton && hideRoomDetailsButton.addEventListener('click', () => this.hideRoomDetails(roomListItem));
    });
  }

  showRoomDetails(roomItem) {
    const content = roomItem.querySelector('.js-room-details-content');
    const showRoomDetailsButton = roomItem.querySelector('.js-show-room-details');
    const hideRoomDetailsButton = roomItem.querySelector('.js-hide-room-details');

    content.classList.remove('d-none');
    showRoomDetailsButton.classList.remove('d-block','d-md-none');
    showRoomDetailsButton.classList.add('d-none');
    hideRoomDetailsButton.classList.remove('d-none');
    hideRoomDetailsButton.classList.add('d-block');
  }

  hideRoomDetails(roomItem) {
    const content = roomItem.querySelector('.js-room-details-content');
    const showRoomDetailsButton = roomItem.querySelector('.js-show-room-details');
    const hideRoomDetailsButton = roomItem.querySelector('.js-hide-room-details');

    content.classList.add('d-none');
    showRoomDetailsButton.classList.remove('d-none');
    showRoomDetailsButton.classList.add('d-block','d-md-none');
    hideRoomDetailsButton.classList.remove('d-block');
    hideRoomDetailsButton.classList.add('d-none');
  }
}



/** WEBPACK FOOTER **
 ** ./assets/js/pages/rooms.js
 **/